const PesquisarPreVendaController = ControllerBase.extend({
    name: "PesquisarPreVendaController",
    region: '#pesquisar-prevenda-region',
    initialize: function () {
        this.menuConsultaProdutosController = new MenuConsultaProdutosController({
            controller: this,
            orcamento: this.orcamento
        });
    },

    form: "#form-pesquisar-prevenda",

    ajax: function () {
        
        return {
            url: "/Produto/_PesquisarPreVenda",
            type: "get",
            cache: false
        };
    },

    events: {

    },

    renderizado: function () {
        this.atacharEventos();
        this.configurarForm();
        $("#pesquisar-prevendas").click();
    },

    atacharEventos: function () {
        $("#pesquisar-prevendas").click($.proxy(this.pesquisarClick, this));
        $("#remover-pesquisa-prevendas").click($.proxy(this.removerPesquisaPreVendaClick, this));
    },

    configurarForm: function () {

        var self = this;

        this.validationOptions = {
            errorClass: "obrigatorio",
            onkeyup: false,
            errorPlacement: function (error, element) {
                return true;
            },
            focusInvalid: false,
            invalidHandler: function (event, validator) {

                var errors = validator.numberOfInvalids();

                if (errors) {
                    var messages = new Array();

                    $.each(validator.errorList,
                        function () {
                            messages.push(this.message);
                        });

                    global.showErrorMessage(messages);

                    return false;
                }

            }
        };

        $(this.form).validate(this.validationOptions);
        $(this.form).submit(function (e) {
            e.preventDefault();
            $("#pesquisar-prevendas").click();
        });

    },

    pesquisar: function (e, numeroPagina) {
        
        if (e) {
            e.preventDefault();
        }
        
        global.blockUI();

        var formdata = global.convertFormToJSON({ selector: this.form });
       
        formdata.TamanhoPagina = this.pesquisa && this.pesquisa.PageSize > 0 ? this.pesquisa.PageSize : 20;
        formdata.NumeroPagina = this.pesquisa && this.pesquisa.ActualPage > 0 ? this.pesquisa.ActualPage : 1;

        if (numeroPagina)
            formdata.NumeroPagina = numeroPagina;

        var self = this;

        global.ajax({
            url: "/Produto/PesquisarPreVenda",
            type: "post",
            contentType: "application/json",
            data: global.toJSONString(formdata),
            error: function () {
                global.unblockUI();
                global.showErrorMessage("Ocorreu um problema com a requisição, por favor tente novamente.");
            },
            success: function (data) {

                if (!data)
                    $("#prevendas-region").hide();
                else {
                    self.carregar(data);
                }
            }
        });
        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
    },

    paginar: function (e) {
        this.pesquisa.ActualPage = e.page;
        this.pesquisar();
    },

    removerPesquisaPreVendaClick: function (e) {

        if (e) {
            e.preventDefault();
        }

        $("#Localizar").val('');
        this.pesquisar(e, 1); // Pesquisa sempre a primeira página.
    },

    pesquisarClick: function (e) {

        if (e) {
            e.preventDefault();
        }

        this.pesquisar(e, 1); // Pesquisa sempre a primeira página.
    },

    carregar: function (data) {

        if (!data) {
            return;
        }

        this.pesquisa = data;

        this.preVendasView = this.showView({
            region: {
                name: "prevendasRegion",
                selector: "#prevendas-region"
            },
            view: {
                type: PreVendasView,
                args: {
                    collection: new PreVendas(data.Entities),
                    orcamento: this.orcamento,
                    adicionarProdutosPreVendaCallback: $.proxy(this.adicionarProdutosPreVenda, this),
                    permitirSelecionar: true
                }
            }
        });

        this.paginador = new Paginator({
            container: "#pesquisar-prevendas-page-container",
            data: data,
            pageClickCallback: $.proxy(this.paginar, this)
        });

        $("html, body").animate({ scrollTop: $("#pesquisar-produtos").offset().top - 50 }, 300);

        $("input").on('focus', function () { $(this).select(); });
        $("textarea").on('focus', function () { $(this).select(); });
        global.unblockUI();
    },
   
    obterProdutoSelecionado: function () {
        return this.model;
    },

    adicionarProdutosPreVenda: function (preVendas) {

        if (this.adicionarProdutosPreVendaCallback) {
            this.adicionarProdutosPreVendaCallback(preVendas);
        }  

    }
})

window.PesquisarPreVendaController = PesquisarPreVendaController

export {
    PesquisarPreVendaController
}